const createTemplate = () =>
    import("@/views/notificationTemplate/createTemplate.vue");
const templateEdit = () =>
    import("@/views/notificationTemplate/templateEdit.vue");
const templateList = () =>
    import("@/views/notificationTemplate/templateList.vue");
export default {
    path: "notification-template",
    meta: {
        label:"Notification Template",
        requiresAuth: true,
    },
    component: {
        render(c) {
            return c("router-view");
        },
    },
    children: [
        {
            path: "create",
            name: "Create-notification-template",
            meta: {
                label: "Create Notification Template",
                requiresAuth: true,
            },
            component: createTemplate,
        },
        {
            path: "edit/:id",
            name: "edit-template",
            meta: {
                label: "Edit Template",
                requiresAuth: true,
            },
            component: templateEdit,
        },
        {
            path: "",
            name:"template List",
            meta: {
                label:"Template List",
                requiresAuth: true,
            },
            component: templateList,

        }
    ]
}    